<template>
    <div id="app">
        <div class="background-animation">
            <div v-for="bubble in bubbles" :key="bubble.id" class="bubble" :style="bubble.style"></div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            bubbles: [],
        };
    },
    mounted() {
        this.createBubbles();
    },
    methods: {
        createBubbles() {
            const colors = ['#6366f1', '#8b5cf6', '#d946ef', '#ec4899', '#f43f5e', '#0ea5e9'];
            const numBubbles = 50;

            for (let i = 0; i < numBubbles; i++) {
                this.bubbles.push({
                    id: i,
                    style: {
                        left: `${Math.random() * 100}vw`,
                        top: `${Math.random() * 100}vh`,
                        transform: `scale(${Math.random()})`,
                        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
                        animationDuration: `${Math.random() * 2 + 3}s`,
                        animationDelay: `${Math.random() * 2}s`,
                    },
                });
            }
        },
    },
};
</script>

<style>
:root {
    --color-primary: #6366f1;
    --color-secondary: #8b5cf6;
    --color-accent: #ec4899;
    --color-background: #0f172a;
    --color-background-light: #1e293b;
    --color-text: #f8fafc;
    --color-text-muted: #94a3b8;
    --color-border: #334155;
    --color-card: rgba(30, 41, 59, 0.7);
    --color-netflix: #f43f5e;
    --color-disney: #0ea5e9;
    --color-amazon: #22c55e;
    --color-hbo: #a855f7;
    --color-spotify: #22c55e;
    --color-youtube: #ef4444;
    --color-accent-hover: #be185d;
}

body {
    font-family: 'Roboto', sans-serif;
    background-color: var(--color-background);
    color: var(--color-text);
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    min-height: 100vh;
}

.background-animation {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden;
    background: linear-gradient(to bottom right, #0f172a, #1e293b);
}

.bubble {
    position: absolute;
    border-radius: 50%;
    opacity: 0.1;
    width: 20px;
    height: 20px;
    filter: blur(3px);
    animation: float 5s infinite ease-in-out;
}

@keyframes float {
    0%,
    100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-20px) scale(1.1);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

button {
    cursor: pointer;
    transition: all 0.3s ease;
}

a {
    text-decoration: none;
    transition: all 0.3s ease;
}
</style>
